import { track } from "./analytics";
import CoralogixLogger from "./coralogix";

/* eslint-disable consistent-return */
const log = (logLevel: string, message: string, exception?: any, data = {}) => {
  const logData = {
    ...data,
    logLevel,
    exception: exception instanceof Error ? exception.message : exception,
  };

  switch (logLevel) {
    case "critical":
      // console doesn't have the Rollbar equivalent of "critical"-level messages
      console.error(message, "\n", data, "\n", exception);
      CoralogixLogger.logError(message, exception, {
        ...logData,
        severity: "critical",
      });
      track("error", {
        message,
        level: "critical",
        ...data,
      });
      break;

    case "error":
      console.error(message, "\n", data, "\n", exception);
      CoralogixLogger.logError(message, exception, logData);
      track("error", {
        message,
        level: "error",
        ...data,
      });
      break;

    case "warning":
      console.warn(message, "\n", data, "\n", exception);
      CoralogixLogger.logWarning(message, logData);
      break;

    case "info":
      console.info(message, "\n", data, "\n", exception);
      CoralogixLogger.logInfo(message, logData);
      break;

    case "debug":
      console.debug(message, "\n", data, "\n", exception);
      CoralogixLogger.logInfo(message, { ...logData, level: "debug" });
      break;

    default:
      console.log(message, "\n", data, "\n", exception);
      CoralogixLogger.logInfo(message, { ...logData, level: "log" });
      break;
  }
};

const critical = log.bind(this, "critical");
const error = log.bind(this, "error");
const warning = log.bind(this, "warning");
const info = log.bind(this, "info");
const debug = log.bind(this, "debug");

export default { critical, error, warning, info, debug, log };
